// @ts-check

/** @type import("../../types/themes").PartialTokensGenerator  */
const tokens = (palette, aliases) => ({
  action: {
    default: {
      bullet: aliases.neutral["400"],
      bulletHover: aliases.neutral["500"],
      marker: aliases.neutral["500"],
    },
    selected: {
      background: aliases.highlight["100"],
      backgroundHover: aliases.highlight["200"],
      bullet: aliases.highlight["200"],
      bulletHover: aliases.highlight["300"],
    },
  },
  button: {
    highlight: {
      background: aliases.highlight["400"],
      backgroundHover: aliases.highlight["300"],
    },
    overlay: {
      backgroundActiveHover: `${aliases.neutral["999"]}33`,
      backgroundHover: `${aliases.neutral["999"]}33`,
      borderActive: aliases.neutral["999"],
      borderHover: `${aliases.neutral["999"]}66`,
    },
  },
  input: {
    default: {
      borderHover: aliases.highlight["200"],
    },
  },
  label: {
    default: {
      background: aliases.neutral["300"],
      backgroundHover: aliases.neutral["400"],
      border: aliases.neutral["500"],
    },
    highlight: {
      background: aliases.highlight["100"],
      backgroundHover: aliases.highlight["200"],
      border: aliases.highlight["400"],
    },
    error: {
      background: aliases.error["100"],
      backgroundHover: aliases.error["200"],
      border: aliases.error["400"],
    },
    warning: {
      background: aliases.warning["100"],
      backgroundHover: aliases.warning["200"],
      border: aliases.warning["400"],
    },
    success: {
      background: aliases.success["100"],
      backgroundHover: aliases.success["200"],
      border: aliases.success["400"],
    },
  },
  navigationItem: {
    default: {
      backgroundActive: aliases.highlight["100"],
      backgroundActiveHover: aliases.highlight["200"],
    },
    selected: {
      backgroundActive: aliases.highlight["100"],
      backgroundActiveHover: aliases.highlight["200"],
    },
  },
  radio: {
    default: {
      background: aliases.neutral["400"],
    },
  },
  ruleBuilder: {
    variant1: {
      background: palette.gray["300"],
      backgroundHover: palette.gray["400"],
    },
  },
  switch: {
    off: {
      background: aliases.neutral["500"],
      backgroundHover: aliases.neutral["600"],
    },
    on: {
      background: aliases.highlight["500"],
      backgroundHover: aliases.highlight["600"],
    },
  },
  tableCell: {
    default: {
      backgroundActiveHover: aliases.neutral["400"],
    },
  },
});

export default tokens;
